import React, { useState } from 'react';
import axios from 'axios';
import '../../css/editor.css';
import ApiService from '../../../../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

import Add from '../../../../media/add.png';
import Teacher from '../../../../media/teacher.png';

import Back from '../../../../media/back.png';

import QuillEditor from '../../../../services/quill_editor';
import TinyMCEEditor from '../../../../services/tinymce';

const CreateTeacher = () => {
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    professional_qualification: '',
    about_me: '',
    img_profile: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({
      ...prev,
      img_profile: e.target.files[0]
    }));
  };

  const validate = () => {
    const errs = {};

    if (!form.first_name.trim()) {
      errs.first_name = ["Nome obbligatorio", true];
    }

    if (!form.last_name.trim()) {
      errs.last_name = ["Cognome obbligatorio", true];
    }

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);

      await ApiService.newTeacher(form);

      toast.success('Insegnante creato con successo!');

      setForm({
        first_name: '',
        last_name: '',
        professional_qualification: '',
        about_me: '',
        img_profile: null,
      });

      setErrors({});

      navigate('/admin/insegnanti');

    } catch (err) {
      console.error(err);
      toast.error('Errore durante la creazione');

    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      
      <h2>
        <img
          src={Teacher}
          alt="crea insegnante"
          className="section-image"
        />
        {' '}
        Crea insegnante
      </h2>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/insegnanti`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco degli insegnanti
      </button>

      <label>Nome *</label>

      <input
        type="text"
        name="first_name"
        value={form.first_name}
        onChange={handleChange}
        className={`input ${errors.first_name ? "error" : ""}`}
        maxLength={250}
      />

      {errors.first_name && (
        <span className='error'>
          {errors.first_name}
        </span>
      )}

      <label>Cognome *</label>

      <input
        type="text"
        name="last_name"
        value={form.last_name}
        onChange={handleChange}
        className={`input ${errors.last_name ? "error" : ""}`}
        maxLength={250}
      />

      {errors.last_name && (
        <span className='error'>
          {errors.last_name}
        </span>
      )}

      <label>Qualifica professionale</label>

      <input
        type="text"
        name="professional_qualification"
        value={form.professional_qualification}
        onChange={handleChange}
        maxLength={250}
      />

      <label>Informazioni aggiuntive insegnante</label>

      <TinyMCEEditor
        value={form.about_me}
        onChange={(content) =>
          setForm((prev) => ({
            ...prev,
            about_me: content
          }))
        }
        placeholder="Scrivi eventuali informazioni aggiuntive utili"
      />

      <div className='attachstyle'>
        
        <label
          style={{
            display: "inline-block",
            padding: "10px 16px",
            background: "#393939",
            color: "white",
            borderRadius: "8px",
            cursor: "pointer",
            marginTop: "0"
          }}
        >
          + Immagine profilo

          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </label>

        {form.img_profile && (
          <div
            className='attachstyle2'
            style={{ padding: "20px" }}
          >
            <img
              src={URL.createObjectURL(form.img_profile)}
              alt="preview"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "16px",
                marginRight: "10px",
                objectFit:'cover'
              }}
            />

            {form.img_profile.name}
          </div>
        )}
      </div>

      <button
        disabled={saving}
        type="submit"
        style={{ marginTop: "50px" }}
      >
        <img
          src={Add}
          alt="Aggiungi"
          className="button-image2"
        />

        {saving
          ? 'Creazione in corso...'
          : 'Crea insegnante'}
      </button>

    </form>
  );
};

export default CreateTeacher;